export const theme = {
  dark: {
    background: '#121212',
    cardBackground: '#1e1e1e',
    textPrimary: '#ffffff',
    textSecondary: '#a3a3a3',
    border: '#2a2a2a',
    inputBg: '#2a2a2a',
    accent: '#9333ea',
    aiBubble: '#2d1b4e',
    userBubble: '#1e1e1e'
  },
  light: {
    background: '#f9fafb',
    cardBackground: '#ffffff',
    textPrimary: '#111827',
    textSecondary: '#4b5563',
    border: '#e5e7eb',
    inputBg: '#ffffff',
    accent: '#9333ea',
    aiBubble: '#f3e8ff',
    userBubble: '#f1f5f9'
  }
};